import Iconify from "minimals-template/components/Iconify"
import SubscriptionCard from "../components/SubscriptionCard"
import { Button, Divider, Grid, RadioGroup, Stack, Typography } from "@mui/material"
import { ShareLinkContactCard } from "plugins/Paywall/components/ShareLinkContactCard"
import { displayIntervalLookup } from "../paywall-constants"
import { getStripeSubscription } from "plugins/stripe/controller/get-stripe-subscription"
import { useUserMetadata } from "lib/store/user"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

function LicenceSelectPage({ setPage, selectedLicense, setSelectedLicense }) {
    const meta = useUserMetadata()
    const { stripeCustomer } = meta || {}
    const { links = [] } = useBoundContext()
    const { data } = getStripeSubscription.useResults.status(stripeCustomer || "")
    const { amount, expiry, period, status, mode, portalUrl } = data || {}
    const msExpiry = expiry * 1000
    const displayPeriod = displayIntervalLookup[period]
    const licensed = data && msExpiry && msExpiry > Date.now()
    const hasLinks = links.length > 0
    const hasViewableLinks = links.some((link) => link.canViewWithoutLicense)
    const title = getTitle()
    const description = getDescription()
    return (
        <>
            <Stack spacing={2}>
                <Typography variant="h4">{title}</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {description}
                </Typography>
                <Divider flexItem />
            </Stack>
            {licensed && (
                <>
                    <Typography variant="body1" color="textSecondary">
                        <Iconify sx={{ color: "success.main", mr: 2 }} icon="mdi:tick" />
                        {`You have purchased a ${displayPeriod} license for ${(amount / 100).toLocaleString("en-gb", {
                            style: "currency",
                            currency: "GBP",
                        })}, which expires on `}
                        <span style={{ color: "rgb(53, 129, 139)" }}>{new Date(msExpiry).toLocaleString()} </span>
                        unless renewed. Monthly or yearly subscriptions should renew automatically.
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                        Status: {status}
                    </Typography>
                    {mode === "subscription" && portalUrl && (
                        <Button variant="contained" sx={{ m: 1 }} onClick={() => window.open(portalUrl, "_blank")}>
                            Manage Subscription
                        </Button>
                    )}
                </>
            )}
            <form>
                <RadioGroup name="licenseType" value={selectedLicense} onChange={licenseChange}>
                    <Grid container spacing={2} sx={{ mt: 0, mb: 6 }} justifyContent={hasLinks ? "center" : "left"}>
                        {hasLinks && <ShareLinkContactCard selected={selectedLicense} onSelect={licenseChange} />}
                        <SubscriptionCard selected={selectedLicense === "subscription"} setPage={setPage} />
                    </Grid>
                </RadioGroup>
            </form>
        </>
    )

    function licenseChange(event) {
        const licenseType = event.target.value
        setSelectedLicense(licenseType)
    }

    function getTitle() {
        if (hasViewableLinks) return "Shared schedules available"
        return "You need a licence to continue"
    }

    function getDescription() {
        if (hasViewableLinks) return "Open a share link below to view the schedules shared with you."
        return "You do not currently have access to SFG20, you will need a licence to continue."
    }
}

export default LicenceSelectPage
